import React from 'react';
import PropTypes from 'prop-types';
import styles from './ExpandableDetail.module.scss';
import ChevronDown from '../../../assets/svg/Feather/ChevronDown';
import ChevronRight from '../../../assets/svg/Feather/ChevronRight';

function ExpandableDetailHeader(props) {
  let titleClass = [styles.title];

  if (!props.label) {
    titleClass.push(styles.uppercase);
  }

  titleClass = titleClass.join(' ');

  return (
    <div className={styles.expandableDetailHeader} onClick={props.onClickExpand} style={props.style}>
      <div className={styles.titleContainer}>
        {
          props.titleIcon &&
          <i className={styles.icon}>{props.titleIcon}</i>
        }
        <div>
          {
            props.label &&
            <h3 className={styles.label}>{props.label}</h3>
          }
          <h2 className={titleClass}>{props.title}</h2>
        </div>
      </div>
      <div className={styles.actionButtons}>
        <button className={styles.headerIcon} style={{alignSelf: 'flex-end'}}>
          {props.isExpanded ? <ChevronDown width={20} color='#ffffff' /> : <ChevronRight width={20} color='#ffffff' />}
        </button>
      </div>
    </div>
  );
}

ExpandableDetailHeader.propTypes = {
  titleIcon: PropTypes.object,
  title: PropTypes.string,
  label: PropTypes.string,
  style: PropTypes.object,
  onClickExpand: PropTypes.func,
  isExpanded: PropTypes.bool,
};

export default ExpandableDetailHeader;
